
import { ArrowRight } from "lucide-react";
import ChartCard from "./ChartCard";
import { Button } from "@/components/ui/button";

const areaChartData = [
  { name: "01", giriş: 4000, çıkış: 2400, stok: 2400 },
  { name: "02", giriş: 3000, çıkış: 1398, stok: 2210 },
  { name: "03", giriş: 2000, çıkış: 9800, stok: 2290 },
  { name: "04", giriş: 2780, çıkış: 3908, stok: 2000 },
  { name: "05", giriş: 1890, çıkış: 4800, stok: 2181 },
  { name: "06", giriş: 2390, çıkış: 3800, stok: 2500 },
  { name: "07", giriş: 3490, çıkış: 4300, stok: 2100 },
];

const barChartData = [
  { name: "A Paketi", tamamlanan: 54, planlanan: 23 },
  { name: "B Paketi", tamamlanan: 42, planlanan: 31 },
  { name: "C Paketi", tamamlanan: 22, planlanan: 44 },
  { name: "D Paketi", tamamlanan: 15, planlanan: 33 },
  { name: "E Paketi", tamamlanan: 36, planlanan: 24 },
];

const ChartSection = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
      <ChartCard 
        title="Stok Hareketleri"
        description="Günlük giriş ve çıkış miktarları"
        type="area"
        data={areaChartData}
        dataKeys={["giriş", "çıkış", "stok"]}
        colors={["#0ea5e9", "#f97316", "#8b5cf6"]}
        action={
          <Button variant="ghost" size="sm" className="gap-1">
            Detaylar <ArrowRight className="h-4 w-4" />
          </Button>
        }
      />
      
      <ChartCard 
        title="Yardım Paketi Dağıtımı"
        description="Tamamlanan ve planlanan dağıtımlar"
        type="bar"
        data={barChartData}
        dataKeys={["tamamlanan", "planlanan"]}
        colors={["#10b981", "#a3e635"]}
        action={
          <Button variant="ghost" size="sm" className="gap-1">
            Rapor <ArrowRight className="h-4 w-4" />
          </Button>
        }
      />
    </div>
  );
};

export default ChartSection;
